import Http from 'services/Http';
import { configs } from 'config';

const portalHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

/**
 * Api class
 *
 * Responsible for all calls to servers
 *
 * Has two objects:
 *
 * - public:   the main API
 * - insights: the insights API
 *
 * Calls to public are made on the service itself:
 *
 *    Api.query(...)
 *
 * Calls to insights are made on the child object:
 *
 *    Api.insights.query(...)
 *
 * // TODO Hook in progress bars, etc
 */
export default {
  get(path, args) {
    let options = { ...args };

    if (args && args.contentType === 'json') {
      options = {
        ...options,
        headers: {
          'Content-Type': 'application/json',
        },
      };
    }
    if (args && args.params) {
      options = {
        ...options,
        headers: {
          'Content-Type': 'application/json',
        },
      };

      options.params = args.params;
    }

    return Http.get(`${configs().API_URL}/${path}`, options);
  },

  post(path, data = null) {
    return Http.post(`${configs().API_URL}/${path}`, data);
  },

  put(path, data = null) {
    return Http.put(`${configs().API_URL}/${path}`, data);
  },

  delete(path, data = null) {
    return Http.delete(`${configs().API_URL}/${path}`, data);
  },

  query(query, variables) {
    return Http.post(`${configs().API_URL}/v2/gql`, { query, variables });
  },

  insights: {
    get(path) {
      return Http.get(`${configs().INSIGHTS_URL}/v1/${path}`);
    },

    post(path, data = null) {
      return Http.post(`${configs().INSIGHTS_URL}/v1/${path}`, data);
    },

    query(data) {
      if (typeof data === 'object') {
        data = JSON.stringify(data, null, '  ');
      }
      return Http.post(`${configs().INSIGHTS_URL}/v1/data`, data);
    },
  },
  ganderPortal: {
    get(path, args) {
      const options = {
        headers: portalHeaders,
      };

      if (args && args.params) {
        options.params = args.params;
      }

      return Http.get(`${configs().FIREHOSE_PORTAL_URL}/v1/${path}`, options);
    },

    put(path, data = null) {
      const options = {
        headers: portalHeaders,
      };

      return Http.put(
        `${configs().FIREHOSE_PORTAL_URL}/v1/${path}`,
        data,
        options
      );
    },

    patch(path, data = null) {
      const options = {
        headers: portalHeaders,
      };

      return Http.patch(
        `${configs().FIREHOSE_PORTAL_URL}/v1/${path}`,
        data,
        options
      );
    },

    delete(path, data = null) {
      return Http.delete(`${configs().FIREHOSE_PORTAL_URL}/v1/${path}`, data);
    },
  },
};
